import { render, staticRenderFns } from "./ProjectClientData.vue?vue&type=template&id=6fcbbdcb&scoped=true&"
import script from "./ProjectClientData.vue?vue&type=script&lang=js&"
export * from "./ProjectClientData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcbbdcb",
  null
  
)

export default component.exports